/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { LoadingSpinnerService } from "./../loading-spinner/loading-spinner.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-server-error",
  templateUrl: "./server-error.component.html",
  styleUrls: ["./server-error.component.scss"],
})
export class ServerErrorComponent implements OnInit {
  showError = false;
  errorTextMsg: string;
  loggedin: boolean;
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _loadingSpinnerService: LoadingSpinnerService
  ) {}

  ngOnInit() {
    this.loggedin = localStorage.getItem("username") ? true : false;
    if (this._activatedRoute.queryParams.hasOwnProperty("errorMsg")) {
      this.errorTextMsg = this._activatedRoute.snapshot.queryParams.errorMsg;
    } else {
      this.errorTextMsg =
        "Error occurred at services, please contact support/admin team";
    }
    document.body.style.overflowY = "auto";
    this._loadingSpinnerService.hide();
    this.showError = true;
    this._router.navigate(["/error"], { replaceUrl: true });
  }
  closeErrorModal() {
    this._router.navigate(["/home"]);
    this.showError = false;
  }
  closeErrorModal1() {
    this._router.navigate(["/login"]);
    this.showError = false;
  }
}
